import React, { Component } from 'react';
import ReactLoading from 'react-loading';
import Avatar from 'react-avatar';
import './MovMinMainPnl.css';
import image from '../../../images/public/userarea/profilee.png';
import crdscia from '../../../images/public/userarea/crdscia.png';
import crdsciblock from '../../../images/public/userarea/crdsciblock.png';
import alertb from '../../../images/public/userarea/alertb.png';

class MovMinMainPnl extends Component {

    constructor(props) {
        super(props);
        console.log("props in [MovMinMainPnl] 1: rendering All skiers in rows", props);
        
        this.textmov = props.textmov ? props.textmov : "Text missing!";
        this.imageProfile = props.imageProfile ? props.imageProfile : image;

        this.state = {
            Activemin: true,
            Blockmin: false,
            Alert: false,
        };

        this.onClick = this.onClick.bind(this);
    }

    onClick = () => {
        console.log("onckillllllc");
        
        this.props.onClick(this.props.item);
    }

    render() {
        return (
            // <div className="movmainPnlmin" style={{ flex: 1 }}>
            //     {this.state.Activemin ?
            //         <div className="movcardTypemin" style={{ flex: 1 }}>
            //             <img src={crdscia} className="responsivemovCardmin" />
            //         </div> : null
            //     }
            //     {this.state.Blockmin ?
            //         <div className="movcardTypebmin" style={{ flex: 1 }}>
            //             <img src={crdsciblock} className="responsivemovCardbmin" />
            //         </div> : null
            //     }
            //     <div className="movprofilemin">
            //         {/* <img src={this.imageProfile} className="responsivemovProfilemin" /> */}
            //         <Avatar  src={this.imageProfile}  className="responsivemovProfilemin" size={'100%'} round="50%" />

            //     </div>
            //     <div className="movfullNamemin" style={{ flex: 1 }}>
            //         {this.textmov}
            //     </div>
            //     {this.state.Alert ?
            //         <div className="movalertbmin">
            //             <img src={alertb} className="responsive" />
            //         </div> : null
            //     }
            //     <button className="arrownBtn" onClick={this.onClick}></button>
            // </div>

        <div className="movmainPnlmin p-3 d-flex align-items-center">
          <div className="container-fluid">
            <div className="row">
              <div className="col-auto">
                <div className="sn_card_profile_wrap">
                  {
										this.state.Activemin ?
										<div className="cardTypemin">
											<img src={crdscia} className="img-fluid" />
										</div> : null
                  }
                  {
										this.state.Blockmin ?
										<div className="cardTypebmin">
											<img src={crdsciblock} className="responsivemovCardbmin" />
										</div> : null
                  }
                  <div className="profilemin">
										<img src={this.imageProfile} className="responsivemovProfilemin" />
										{/* <Avatar  src={this.imageProfile}  className="responsivemovProfilemin" size={'100%'} round="50%" /> */}
                  </div>
                </div>
              </div>
              <div className="col d-flex align-items-center">
                <div className="movfullNamemin flex-grow-1">
									{this.textmov}
                </div>
                {
									this.state.Alert ?
                  <div className="movalertbmin">
										<img src={alertb} className="img-fluid" />
                  </div> : null
                }
              </div>
              <div className="col d-flex align-items-center justify-content-end">
                <button className="arrownBtn" onClick={this.onClick}></button>
              </div>
            </div>
          </div>
        </div>
        );
    }
}

export default MovMinMainPnl;


// WEBPACK FOOTER //
// ./src/assets/components/panel/MovMinMainPnl.js